import { useCallback, useEffect } from 'react';

const className = 'scroll-lock';

export const useScrollLock = (lockOn?: boolean) => {
  const lockPageScroll = useCallback(() => {
    const html = document.querySelector('html')!;
    if (!html || html.classList.contains(className)) {
      return;
    }
    html.classList.add(className);
  }, []);

  const unlockPageScroll = useCallback(() => {
    const html = document.querySelector('html')!;
    if (!html || !html.classList.contains(className)) {
      return;
    }
    html.classList.remove(className);
  }, []);

  useEffect(() => {
    if (typeof lockOn !== 'boolean') {
      return () => {};
    }
    if (lockOn) {
      lockPageScroll();
    }
    if (!lockOn) {
      unlockPageScroll();
    }
    return () => unlockPageScroll();
  }, [lockOn]);

  return {
    lockPageScroll,
    unlockPageScroll,
  };
};
